<nav class="navbar custom-navbar bg-faded main-header px-3">

    <a href="javascript:;" id="header-sidebar-toggle" class="nav-link ps-0 d-lg-none mobile-menu-toggle" (click)="toggleSidenav.emit()">
      <i class="icon ion-android-menu"></i>
    </a>

    <span class="navbar-heading me-3" id="header-heading-title">{{heading}}</span>

    <app-global-search class="ms-3 d-none d-md-block"></app-global-search>

    <span class="ms-auto"></span>

    @if (canCheckIn()) {
      <div class="checkin-link">
        @if (!(userType() == 'nutrition' || userType() == 'sales' || userType() == 'salesmanager')) {
          <button class="btn custom-btn" id="header-checkin-btn" (click)="openCheckInModal(chekInModal)">Check In</button>
        }
      </div>
    }

    <div ngbDropdown display="dynamic" >
      <button class="btn btn-link" id="header-account-toggle" ngbDropdownToggle>Admin</button>
      <div ngbDropdownMenu aria-labelledby="header-account-toggle" class="dropdown">
        <!-- <button class="btn btn-link" (click)="toUserProfile()" ngbDropdownItem> <i class="fas fa-user"></i> &nbsp; My Profile</button> -->
        <!-- <div class="dropdown-divider"> -->
        <!-- <button class="btn btn-link" ngbDropdownItem><i class="fas fa-lock"></i> &nbsp; Lock</button> -->
        @if (userType() == 'trainer' || userType() == 'headtrainer') {
          <button class="btn btn-link" id="header-outlook-assign-btn" (click)="integrateWithOutlook()" ngbDropdownItem>
          <i class="fas fa-retweet"></i> &nbsp;
          Integrate with Outlook</button>
        }
        <button class="btn btn-link" id="header-change-password-btn" (click)="changePassword(changePasswordModal)" ngbDropdownItem><i
            class="fas fa-lock"></i> &nbsp;
          Change Password</button>
        <button class="btn btn-link" id="header-logout-btn" (click)="logout()" ngbDropdownItem><i class="fas fa-sign-out-alt"></i> &nbsp;
          Logout</button>
        <!-- </div> -->
      </div>
    </div>

</nav>
<ng-template #chekInModal let-close="close">
  <div class="modal-header">
    <h3 class="modal-title" id="header-modal-checkin-title" ngbAutofocus >Check in</h3>
    <button type="button" id="header-modal-checkin-close-btn" class="btn-close" aria-label="Close" (click)="closeCheckInModal()">
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="card-body">
        <div class="row">
          <div class="col-12 text-center check-by">
            <h4 (click)="checkInWay('manual')" id="header-modal-checkin-manual-tab" class="upperCase">Manual check In</h4>
          </div>
        </div>
        <div class="row check-in-way" [ngClass]="{'manual': wayToCheckIn()=='manual'}">
          <div class="col-12">
            <!-- <form #chekInForm> -->
              <div class="row">
                <div class="col-12">
                  <fieldset class="form-group mb-4">
                    <input type="text" id="header-modal-checkin-user-code-input" name="user_code" [(ngModel)]="checkedInCode" class="form-control"
                      placeholder="user code" required />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <button type="submit" id="header-modal-checkin-submit-btn" class="btn custom-btn px-3 w-50 m-auto" (click)="CheckInUser()">Check
                    in</button>
                </div>
              </div>
            <!-- </form> -->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="or-divider">
              <span>OR</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center check-by">
            <h4 (click)="checkInWay('camera')" id="header-modal-checkin-camera-tab" class="upperCase">Camera check In</h4>
          </div>
        </div>
        <div class="row check-in-way" [ngClass]="{'camera': wayToCheckIn()=='camera'}">
          <div class="col-12">
            <div class="camera-check-in">
              @if (!cameraAvailable()) {
                <div class="alert alert-warning text-center">
                  Camera access is not available on this device or browser. Please use manual check-in.
                </div>
              }
              
              <!-- Simplified scanner component with minimal props -->
              @if (wayToCheckIn()=='camera' && cameraAvailable()) {
                <zxing-scanner
                  [enable]="scannerEnabled()"
                  (scanSuccess)="scanSuccess($event)"
                  (permissionResponse)="onHasPermission($event)"
                  (scanError)="onCameraError($event)"
                ></zxing-scanner>
              }
              
              @if (wayToCheckIn()=='camera' && !hasCameraPermission() && cameraAvailable()) {
                <div class="mt-3 text-center">
                  <p>Camera permission is required to scan codes.</p>
                  <button class="btn btn-warning mt-2" id="header-modal-checkin-use-manual-btn" (click)="wayToCheckIn.set('manual')">
                    Use Manual Entry Instead
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="bg-cover"></div>
    </div>
  </div>
</ng-template>

<ng-template #changePasswordModal let-close="close">
  <div class="modal-header">
    <h3 class="modal-title" id="header-modal-change-password-title" ngbAutofocus >Change Password</h3>
    <button type="button" id="header-modal-change-password-close-btn" class="btn-close" aria-label="Close" (click)="closeChangePasswordModal()">
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="card-body">
        <form id="header-modal-change-password-form" (ngSubmit)="changePasswordSubmit()">
          <div class=" text-center">
            <div class=" row">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Old Password</mat-label>
                <input matInput type="password" id="header-modal-change-password-old-password-input" placeholder="********" [formField]="changePasswordForm.old_password">
              </mat-form-field>
            </div>
            <div class="row ">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>New Password</mat-label>
                <input matInput type="password" id="header-modal-change-password-new-password-input" placeholder="********" [formField]="changePasswordForm.new_password">
              </mat-form-field>
            </div>
            <div class="row ">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Confirm Password</mat-label>
                <input matInput type="password" id="header-modal-change-password-confirm-password-input" placeholder="********" [formField]="changePasswordForm.confirm_password">
                @if (changePasswordTouched('confirm_password') && changePasswordHasError('confirm_password', 'mismatch')) {
                  <mat-error id="header-modal-change-password-mismatch-error">Passwords do not match</mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex justify-content-center mt-4 mb-4">
            <button class="btn custom-btn mt-2" id="header-modal-change-password-submit-btn" style="padding: 10px 20px;" type="submit"
              [disabled]="changePasswordForm().invalid() || changePasswordLoadingFlag()">{{changePasswordLoadingFlag()? 'Loading...':'Change'}}</button>
          </div>
        </form>

      </div>
      <div class="bg-cover"></div>
    </div>
  </div>
</ng-template>
